// Keep the final drag position until Radix unmounts the exiting sheet.
export const initialMenuMotion = {open:false, offset:0, exitOffset:0, entering:false};
export function menuMotionReducer(state, action) {
    switch (action.type) {
        case 'open': return state.open ? state : {...initialMenuMotion, open:true, entering:true};
        case 'close': return {...state, open:false, exitOffset:state.offset, entering:false};
        case 'drag': return state.open ? {...state, offset:Math.max(0, action.offset), entering:false} : state;
        case 'reset': return state.open ? {...state, offset:0, entering:false} : state;
        case 'dismiss': {
            if (!state.open) return state;
            const offset = Math.max(0, action.offset);
            return {open:false, offset, exitOffset:offset, entering:false};
        }
        case 'entered': return {...state, entering:false};
        default: return state;
    }
}
